import { Link } from 'react-router-dom';
import { useAdminFlights, useAdminInvitations, useAdminUsers } from '../../hooks/use-admin';

function StatCard({
  label,
  value,
  to,
  hint,
}: {
  label: string;
  value: string | number;
  to: string;
  hint?: string;
}) {
  return (
    <Link
      to={to}
      className="block rounded-xl border border-slate-800 bg-slate-900/60 p-4 hover:bg-slate-900"
    >
      <p className="text-xs uppercase tracking-wide text-slate-500">{label}</p>
      <p className="mt-1 text-2xl font-semibold tabular-nums">{value}</p>
      {hint && <p className="mt-1 text-xs text-slate-400">{hint}</p>}
    </Link>
  );
}

export function AdminDashboard() {
  const allUsers = useAdminUsers({ pageSize: 1 });
  const activeFlights = useAdminFlights('ACTIVE');
  const invitations = useAdminInvitations();
  const openInvites =
    invitations.data?.filter((i) => !i.usedAt && new Date(i.expiresAt) > new Date())
      .length ?? 0;

  return (
    <div className="px-4 py-4 space-y-3">
      <h1 className="text-xl font-semibold">Admin-Dashboard</h1>
      <div className="grid grid-cols-2 gap-3">
        <StatCard
          label="Mitglieder gesamt"
          value={allUsers.data?.total ?? '—'}
          to="/admin/users"
        />
        <StatCard
          label="Aktive Flüge"
          value={activeFlights.data?.length ?? '—'}
          to="/admin/flights"
        />
        <StatCard
          label="Offene Einladungen"
          value={openInvites}
          to="/admin/invitations"
        />
        <StatCard
          label="App-Settings"
          value="·"
          to="/admin/settings"
          hint="Ablaufzeit & mehr"
        />
      </div>
    </div>
  );
}
